/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/loan_medium'
export default icon
